import { useEffect, useState } from "react";

const KEY = "ml_cookie_consent";
const CLARITY_ID = process.env.REACT_APP_CLARITY_ID; // heatmaps + enregistrements (Microsoft Clarity)
const GA_ID = process.env.REACT_APP_GA_ID;           // Google Analytics 4 (optionnel)

function loadClarity(id) {
  if (!id || window.clarity) return;
  (function (c, l, a, r, i) {
    c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
    const t = l.createElement(r); t.async = 1; t.src = "https://www.clarity.ms/tag/" + i;
    const y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
  })(window, document, "clarity", "script", id);
}
function loadGA(id) {
  if (!id || window.gtag) return;
  const s = document.createElement("script"); s.async = 1;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`; document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  window.gtag("config", id, { anonymize_ip: true });
}
function enableAnalytics() { loadClarity(CLARITY_ID); loadGA(GA_ID); }

export default function CookieConsent() {
  const [choice, setChoice] = useState(() => { try { return localStorage.getItem(KEY); } catch { return null; } });

  useEffect(() => { if (choice === "accepted") enableAnalytics(); }, [choice]);

  const decide = (val) => { try { localStorage.setItem(KEY, val); } catch {} setChoice(val); };

  if (choice) return null;

  return (
    <div className="fixed bottom-0 inset-x-0 z-[200] p-4 sm:p-6" data-testid="cookie-banner">
      <div className="mx-auto max-w-3xl rounded-2xl border border-white/[0.1] bg-black/90 backdrop-blur-xl p-5 sm:p-6 shadow-2xl">
        <div className="flex flex-col sm:flex-row sm:items-center gap-4">
          <p className="text-sm text-zinc-300 leading-relaxed flex-1">
            On utilise des cookies pour mesurer l'audience et améliorer le site. Vous pouvez accepter ou refuser — votre choix est respecté.{" "}
            <a href="/mentions-legales" className="text-[var(--accent)] hover:underline">En savoir plus</a>.
          </p>
          <div className="flex gap-2 shrink-0">
            <button onClick={() => decide("refused")} className="btn-pill text-sm" data-testid="cookie-refuse">Refuser</button>
            <button onClick={() => decide("accepted")} className="btn-pill btn-pill-accent text-sm" data-testid="cookie-accept">Tout accepter</button>
          </div>
        </div>
      </div>
    </div>
  );
}
